<template>
  <div :class="['custom-alert', alertTypeClass]">
    <div class="custom-alert__content d-flex justify-space-between align-center">
      <span class="font-weight-bold">
        <span v-if="status === 'paid'">Tudo certo! Seu PIX foi confirmado</span>
        <span v-else-if="status === 'pending'">Aguardando pagamento…</span>
        <span v-else-if="status === 'failed'">❌ Falhou / Expirado</span>
        <span v-else>🔎 Verificando…</span>
      </span>
      <div class="loading-circular-pix">
        <v-progress-circular v-if="status === 'pending'" indeterminate :size="22" :width="3" />
        <span v-if="status === 'paid'"><Icon name="fas fa-check-circle" class="mr-2" size="20" /></span>
      </div>
    </div>

  </div>
</template>

<script>
import CartService from '@/scripts/services/cart.service'

export default {
  name: 'PixPaymentStatus',
  props: {
    cartId: {
      type: [Number],
      required: true
    },
    intervalMs: {
      type: Number,
      default: 5000
    }
  },
  data() {
    return {
      cartService: new CartService(),
      status: 'checking', // checking | pending | paid | failed
      isLoading: false,
      _timer: null,
      _isPageVisible: true
    }
  },
  computed: {
    alertTypeClass() {
      if (this.status === 'paid') return 'custom-alert--success'
      if (this.status === 'pending') return 'custom-alert--warning'
      if (this.status === 'failed') return 'custom-alert--error'
      return 'custom-alert--info'
    }
  },
  mounted() {
    this.checkOnce()
    this.startPolling()
    document.addEventListener('visibilitychange', this._onVisibilityChange)
  },
  beforeDestroy() {
    this.stopPolling()
    document.removeEventListener('visibilitychange', this._onVisibilityChange)
  },
  methods: {
    _onVisibilityChange() {
      this._isPageVisible = document.visibilityState === 'visible'
      if (this._isPageVisible && !this._timer && this.status !== 'paid' && this.status !== 'failed') {
        this.startPolling()
      } else if (!this._isPageVisible) {
        this.stopPolling()
      }
    },
    startPolling() {
      if (this._timer) return
      this._timer = setInterval(() => {
        if (this.status === 'paid' || this.status === 'failed') {
          this.stopPolling()
          return
        }
        this.checkOnce()
      }, this.intervalMs)
    },
    stopPolling() {
      if (this._timer) {
        clearInterval(this._timer)
        this._timer = null
      }
    },
    async checkOnce() {
      try {
        this.isLoading = true
        const cartStatus = await this.cartService.getCartStatus(this.cartId)
        if (cartStatus === 5 || cartStatus === 8) {
          this.status = 'paid'
          this.$emit('paid')
        } else if (cartStatus === 9) {
          this.status = 'failed'
        } else {
          this.status = 'pending'
        }
      } catch (e) {
        if (this.status === 'checking') this.status = 'pending'
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.loading-circular-pix{
  display: flex;
  align-items: center;
  justify-content: end;
  padding-right: 5px;
}
.custom-alert {
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 16px;
  margin: 8px 0;
  font-size: 1rem;
  width: 100%;
}

.custom-alert__content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

/* Sucesso */
.custom-alert--success {
  border-color: #4caf50;
  background-color: #e8f5e9;
  color: #256029;
}

/* Aviso */
.custom-alert--warning {
  border-color: #ff9800;
  background-color: #fff3e0;
  color: #663c00;
}

/* Erro */
.custom-alert--error {
  border-color: #f44336;
  background-color: #ffebee;
  color: #b71c1c;
}

/* Info */
.custom-alert--info {
  border-color: #2196f3;
  background-color: #e3f2fd;
  color: #0d47a1;
}
</style>
